import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { Router } from '@angular/router';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { forkJoin, Subscription } from 'rxjs';
import { EmailInboxType } from 'src/app/communications/models/contacts/email-inbox-type';
import { LocalStorageService } from 'src/app/core/services/data/local-storage.service';
import { NotificationService } from 'src/app/core/services/firebase/notification.service';
import { ManagerService } from 'src/app/core/services/http/agency-mgmt/manager.service';
import { EmailLogService } from 'src/app/core/services/http/maintenance/email-log.service';
import { EmailNotificationService } from 'src/app/core/services/http/notifications/email-notification.service';
import {
  EmailNotification,
  EmailNotificationResult,
} from 'src/app/layout/models/email-notification.model';
import { SHOWORGANIZATIONEMAILCOUNT } from 'src/app/shared/constants/local-storage-items.constants';

@Component({
  selector: 'app-email-notifications',
  templateUrl: './email-notifications.component.html',
  styleUrls: ['./email-notifications.component.scss'],
})
export class EmailNotificationsComponent implements OnInit, OnDestroy {
  private subs: Subscription[] = [];
  isEmailListLoading: boolean;
  notifications: EmailNotificationResult = new EmailNotificationResult();
  pageSize: number = 8;
  pageNumber: number = 0;
  pageTotal: number = 0;
  userId :string = '';
  @Input() organizationPmUserIds: string[];
  @Output() closeEvent = new EventEmitter();
  constructor(
    private emailNotifySvc: EmailNotificationService,
    private emailLogSvc: EmailLogService,
    private firebaseSvc: NotificationService,
    private oidcSecurityService: OidcSecurityService,
    private router: Router,
    private localStorageService: LocalStorageService,
    private managerService: ManagerService
  ) {}

  ngOnInit(): void {
    this.userId = this.oidcSecurityService.getPayloadFromIdToken(false).sub;
    this.getEmailNotifications();
  }

  ngOnDestroy(): void {
    this.subs.forEach((sub) => sub.unsubscribe());
  }

  getEmailNotifications(): void {
    if(this.localStorageService.get(SHOWORGANIZATIONEMAILCOUNT)  == "true")
      this.getEmailListbyUserIds(this.organizationPmUserIds.join(','));
    else
    this.getEmailListCurrentUser();
    
  }

  setEmailNotificationAsReadOrUnread(email: EmailNotification, index: number) {

    if(email.userId != this.oidcSecurityService.getPayloadFromIdToken(false).sub)
      return;

    email.isActionClicked = !email.isActionClicked;
    forkJoin([
        this.emailLogSvc.updateEmailReadOrUnreadStatus(email.primaryId, email.optionalValue),
        this.managerService.UpdateUnreadEmailCount(email.isActionClicked, email.userId)
    ]).subscribe();
  }

  openEmail(
    email: EmailNotification,
    index: number
  ): void {
    this.setNotificationAsRead(email);
    this.dismiss();
    this.router.navigate(['/job/job-detail/', email.primaryId], {
      queryParams: { emailId: email.optionalValue },
    });
  }

  setNotificationAsRead(email: EmailNotification) {
    if(email.userId != this.oidcSecurityService.getPayloadFromIdToken(false).sub)
      return;
    this.emailNotifySvc
      .setNotificationActionAsClick(email.id)
      .subscribe((res) => {
      });
  }

  getNotificationsPaginatedResult(event: any) {
    this.pageNumber = event;
    this.getEmailNotifications();
  }

  getEmailListbyUserIds(userIds: string) { 
    this.isEmailListLoading = true;
    
    this.subs[1] = this.emailLogSvc
      .getEmailListByUserIds(
        EmailInboxType.Inbox,
        userIds,
        this.pageNumber + 1,
        '',
        this.pageSize
      )
      .subscribe((res) => {
        this.notifications.emailNotifications = res.emailList;
        this.notifications.pageTotal = res.emailCount;
        this.pageTotal = this.notifications.pageTotal;
        this.isEmailListLoading = false;  
        });
  }

  getEmailListCurrentUser(){
    this.isEmailListLoading = true;
    this.subs[0] = this.emailNotifySvc
      .getEmailNotificationData(this.pageNumber, this.pageSize)
      .subscribe((res) => {
        this.notifications = res;
        this.pageTotal = this.notifications.pageTotal;
        this.isEmailListLoading = false;
      });
  }

  
  isActionDisable(email: EmailNotification) {
    const getEmail = {...email }; 
    return (getEmail.userId != this.oidcSecurityService.getPayloadFromIdToken(false).sub);
  }

  public dismiss() {
    this.closeEvent.emit();
  }

}
